const QuizTopicPromptTest = () => {
    return (
        <h1>prompt test</h1>
    );
};

export default QuizTopicPromptTest;